import notification from "./ic-notification-example.svg";
import schedule from "./ic-schedule.svg";
import insights from "./img-insights-phone.png";
import years from "./img-years-phone.png";

function SectionFeatures() {
    return (
        <div className="w-full flex flex-col space-y-8">
            <h1 className="feature-2">تعرف على ClassQ.</h1>
            <div className='flex flex-col space-y-8' dir="ltr">
                <div className='flex flex-col space-y-8 
                                lg:flex-row lg:space-y-0 lg:space-x-8'>
                    <div id="feature-1" className="feature-1 w-full py-10 px-5 rounded-2xl flex flex-col space-y-10 justify-center items-center bg-slate-200">
                        <img className="drop-shadow-lg h-10" src={notification} alt="notification: Tommorow's sessions" />
                        <h3 className="font-bold text-4xl text-center">إشعارات</h3>
                    </div>
                    <div id="feature-2" className="feature-2 relative w-full py-10 px-5 rounded-2xl flex flex-col justify-center items-center bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sky-200 via-slate-200 to-slate-200">
                        <img className="h-20" src={schedule} alt="Schedule" />
                        <h3 className="font-bold text-4xl text-center bottom-10">تصفح جدولك الزمني</h3>
                    </div>
                </div>
                <div className='flex flex-col space-y-8
                                lg:flex-row lg:space-y-0 lg:space-x-8'>
                    <div id="feature-3" className="feature-3 py-10 px-5 space-y-10 rounded-2xl flex flex-col justify-center items-center bg-slate-200">
                        <img className="w-48" src={insights} alt="insights" />
                        <h3 className="font-bold text-4xl text-center ">متابعة الإحصــائيات</h3>
                    </div>
                    <div className='w-full flex flex-col space-y-8 '>
                        <div className='flex flex-col 
                                        lg:flex-row lg:space-x-8 lg:h-2/3'>
                            <div id="feature-center" className="feature-center w-full py-20 px-5 rounded-2xl bg-secondary lg:block hidden bg-custom-image-center">
                            </div>
                            <div id="feature-4" className="feature-4 w-full px-5 py-20 rounded-2xl flex justify-center items-center bg-custom-image
                                            lg:px-20 lg:w-fit">
                                <h3 className="font-bold text-4xl text-center">قفــل</h3>
                            </div>
                        </div>
                        <div className='flex flex-col space-y-8 
                                        lg:flex-row lg:space-y-0 lg:space-x-8 lg:h-1/3'>
                            <div id="feature-5" className="feature-5 w-full py-20 px-5 rounded-2xl flex justify-center items-center bg-[radial-gradient(ellipse_at_left,_var(--tw-gradient-stops))] from-indigo-500 via-indigo-300 to-indigo-100">
                                <h3 className="font-bold text-4xl text-center">امتلك بياناتك</h3>
                            </div>
                            <div id="feature-6" className="feature-6 relative w-full py-20 px-5 rounded-2xl flex justify-center items-center bg-slate-200">
                                <h3 className="absolute top-1 font-bold text-4xl text-center z-10">صفر ورقة</h3>
                                <img className="absolute bottom-0 h-24
                                                lg:h-auto"
                                    src={years} alt="Year Screen" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SectionFeatures;